import { IKnmPlanFilterRaw } from '../../../APIPackage/PlanListModule/interfaces/IKnmPlanFilterRaw';

export const emptyKnmPlanFilterRaw: IKnmPlanFilterRaw = {
  endDate: '',
  erknmStatuses: [],
  id: null,
  ignoreKno: false,
  isDefault: false,
  isOnlyDeleted: false,
  startDate: '',
  statuses: [],
  name: '',
  knoIds: [],
  prosecutorOrganizationErvkUuids: [],
  types: [],
  isOnlyMine: false,
  childKnoIncluded: false,
  childProsecutorOrgIncluded: false,
  knoErvkUuids: [],
};
